// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title {
  margin-bottom: 10px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

mat-icon {
  font-size: 26px;
  margin-left: 10px;
}

h1 {
  font-size: 1.5rem;
}

mat-paginator {
  direction: ltr !important;
  margin: auto !important;
}

.parent-both {
  display: flex;
  margin: auto;
  padding: 20px;
}

.item-service {
  direction: rtl;
  margin-right: 20px;
  margin-top: 20px;
}

mat-option {
  font-size: small;
}

mat-label {
  font-size: small;
}

mat-select {
  font-size: small;
}

mat-form-field {
  width: 30%;
}

.empty-list {
  text-align: center;
  font-size: medium;
  margin-top: auto;
  margin-bottom: auto;
}

.empty-card {
  margin-top: 10px;
  height: 50px;
}`, "",{"version":3,"sources":["webpack://./src/app/features/request-list/request-list.component.scss","webpack://./../../admin%20project/atramehr-admin/src/app/features/request-list/request-list.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;ACCF;;ADEA;EACE,eAAA;EACA,iBAAA;ACCF;;ADEA;EACE,iBAAA;ACCF;;ADEA;EACE,yBAAA;EACA,uBAAA;ACCF;;ADEA;EACE,aAAA;EACA,YAAA;EACA,aAAA;ACCF;;ADEA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;ACCF;;ADEA;EACE,gBAAA;ACCF;;ADEA;EACE,gBAAA;ACCF;;ADEA;EACE,gBAAA;ACCF;;ADEA;EACE,UAAA;ACCF;;ADCA;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;ACEF;;ADAA;EACE,gBAAA;EACA,YAAA;ACGF","sourcesContent":[".title {\r\n  margin-bottom: 10px;\r\n  margin-top: 10px;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\nmat-icon {\r\n  font-size: 26px;\r\n  margin-left: 10px;\r\n}\r\n\r\nh1 {\r\n  font-size: 1.5rem;\r\n}\r\n\r\nmat-paginator {\r\n  direction: ltr !important;\r\n  margin: auto !important;\r\n}\r\n\r\n.parent-both {\r\n  display: flex;\r\n  margin: auto;\r\n  padding: 20px;\r\n}\r\n\r\n.item-service {\r\n  direction: rtl;\r\n  margin-right: 20px;\r\n  margin-top: 20px;\r\n}\r\n\r\nmat-option {\r\n  font-size: small;\r\n}\r\n\r\nmat-label {\r\n  font-size: small;\r\n}\r\n\r\nmat-select {\r\n  font-size: small;\r\n}\r\n\r\nmat-form-field {\r\n  width: 30%;\r\n}\r\n.empty-list{\r\n  text-align: center;\r\n  font-size: medium;\r\n  margin-top: auto;\r\n  margin-bottom: auto;\r\n}\r\n.empty-card{\r\n  margin-top: 10px;\r\n  height: 50px;\r\n}",".title {\n  margin-bottom: 10px;\n  margin-top: 10px;\n  display: flex;\n  justify-content: center;\n}\n\nmat-icon {\n  font-size: 26px;\n  margin-left: 10px;\n}\n\nh1 {\n  font-size: 1.5rem;\n}\n\nmat-paginator {\n  direction: ltr !important;\n  margin: auto !important;\n}\n\n.parent-both {\n  display: flex;\n  margin: auto;\n  padding: 20px;\n}\n\n.item-service {\n  direction: rtl;\n  margin-right: 20px;\n  margin-top: 20px;\n}\n\nmat-option {\n  font-size: small;\n}\n\nmat-label {\n  font-size: small;\n}\n\nmat-select {\n  font-size: small;\n}\n\nmat-form-field {\n  width: 30%;\n}\n\n.empty-list {\n  text-align: center;\n  font-size: medium;\n  margin-top: auto;\n  margin-bottom: auto;\n}\n\n.empty-card {\n  margin-top: 10px;\n  height: 50px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
